import React from "react";
import { YoutubeProps } from "./types";
import ContentSection from "./ContentSection";
import YoutubeVideo from "../YoutubeVideo";
import cx from "classnames";

const Youtube: React.FC<YoutubeProps> = ({
  data,
  heading,
  align,
  preview = false,
}) => {
  return (
    <ContentSection
      className={cx("my-5 w-full", `align-${align || "left"}`)}
      type={data.type}
      preview={preview}
    >
      {heading}
      <YoutubeVideo {...data} />
    </ContentSection>
  );
};

export default Youtube;
